import { UsersService } from '../services';
import { usersKeys } from '../queryKeys';
import { USERS_SEARCH_DEFAULT_LIMIT } from '../clients/SearchOfficeUsers';
import { toUserSearchParams } from '../locationUserSearch';
import { useUsersPageQuery } from './useUsersPageQuery';

export const LOCATION_USERS_PAGE_SIZE = USERS_SEARCH_DEFAULT_LIMIT;

/**
 * A page of Location Users — office identities — for the list page.
 *
 * The search box value goes through `toUserSearchParams`, so a full phone
 * number is sent as `phone` and anything else as `search`.
 *
 * @param {Object} [params]
 * @param {number} [params.page=1] - 1-based page.
 * @param {string} [params.search=''] - The search box value, as typed.
 */
export const useGetLocationUsers = ({ page = 1, search = '' } = {}) => {
  const searchParams = toUserSearchParams(search);

  const { rows, ...query } = useUsersPageQuery(
    usersKeys.locationUsers(searchParams, page),
    () =>
      UsersService.searchOfficeUsers({
        page,
        limit: LOCATION_USERS_PAGE_SIZE,
        ...searchParams,
      }),
    LOCATION_USERS_PAGE_SIZE,
  );

  return { users: rows, ...query };
};
